import { AdminDetails, FirmAdminUpdateRequest, FirmAdminResponse } from 'store/admins/types';

const exportObject = {
  mapForView: (resData: FirmAdminResponse): AdminDetails => {
    return {
      id: resData.id,
      firstName: resData.first_name,
      lastName: resData.last_name,
      lmcRefNumber: resData.lmc_ref_number,
      company: resData.company.name,
      contactNumber: resData.phone,
      address: {
        buildingNumber: resData.house_number || '',
        buildingName: resData.street_line_1 || '',
        street: resData.street_line_2 || '',
        city: resData.city,
        county: resData.county || '',
        postcode: resData.post_code,
      },
      email: resData.email,
      fcaNumber: resData.company.fca_number,
      isVerified: resData.is_verified,
    };
  },

  mapForSave: (details: AdminDetails): FirmAdminUpdateRequest => {
    return {
      email: details.email || '',
      post_code: details.address.postcode.toUpperCase(),
      house_number: details.address.buildingNumber,
      street_line_1: details.address.buildingName || '',
      street_line_2: details.address.street || '',
      city: details.address.city,
      county: details.address.county || '',
      phone: details.contactNumber || '',
    };
  },
};
export default exportObject;
